import {CalcTrigger} from "@/types/CalcTrigger";
import BerechnungsdetailsTO from "@/types/BerechnungsdetailsTO";

const trackRechnerInput = function (mutationType: string, value: string): void{

  let eventAction = "1_dateneingabe_baudarlehen_";
  let eventActionSub = "";

  switch (mutationType){
    case CalcTrigger.DARLEHEN:
      eventActionSub = "darlehensbetrag";
      break;
    case CalcTrigger.KAUFPREIS:
      eventActionSub = "kaufpreis";
      break;
    case CalcTrigger.SOLLZINSBINDUNG:
      eventActionSub = "sollzinsbindung";
      break;
    case CalcTrigger.RATE:
      eventActionSub = "monatsrate";
      break;
    case CalcTrigger.VOLLTILGUNG:
      eventActionSub = "volltilgung";
      break;
    case CalcTrigger.SONDERTILGUNG:
      eventAction = "1.2_dateneingabe_baudarlehen_";
      eventActionSub = "sondertilgung";
      break;
  }

  //Abfrage für Volltilgung
  if (String(value) === "true")
  {
    value = "ja";
  } else if (String(value) === "false")
  {
    value = "nein";
  }

  if (eventActionSub.length > 0)
  {
    eventAction += eventActionSub;
  }

  trackGAEvent("calc_baudarlehen", eventAction, value);
}

const trackFinBestaetigungInput = function (mutationType: string, value: string): void{

  let eventAction = "1_dateneingabe_baudarlehen_";
  let eventActionSub = "";

  switch (mutationType){
    case CalcTrigger.EINNAHMEN:
      eventActionSub = "mtl_netto";
      break;
    case CalcTrigger.AUSGABEN:
      eventActionSub = "mtl_ausgaben";
      break;
    case CalcTrigger.EIGENKAPITAL:
      eventActionSub= "eigenkapital";
      break;
    case CalcTrigger.KAUFPREIS:
      eventActionSub = "preis";
      break;
  }

  if (eventActionSub.length > 0)
  {
    eventAction += eventActionSub;
  }

  trackGAEvent("calc_fin_bestaetigung", eventAction, value);
}

const trackGAEvent = function (eventCategory: string, eventAction: string, eventLabel: string): void{
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if(window.dataLayer){
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    dataLayer.push({
      'event' : 'GAEvent',
      'eventCategory': eventCategory,
      'eventAction': eventAction,
      'eventLabel': eventLabel
    });
  }
}

const trackProduct = function (berechnungsdetails: BerechnungsdetailsTO, kaufpreis: number){
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if(window.dataLayer) {

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    dataLayer.push({
      'event' : 'eec.view',
      'product' : {
        'action' :  ['detailView'],
        'category' : ['baufinanzieren'],
        'id' : [berechnungsdetails.finanzierungsmodellId],
        'name' : [berechnungsdetails.finanzierungsmodell],
        'amount' : [berechnungsdetails.nettodarlehen],
        'period' : [berechnungsdetails.anzahlRaten],
        'bsp_saving_contribution' : [berechnungsdetails.hoeheMonatlicheRate],
        'bsp_young_people' : [''],
        'bf_ltv' : [Math.round(berechnungsdetails.nettodarlehen/kaufpreis * 100) / 100],
        'requirement' : [''],
        'preference' : [''],
        'term_commitment' : [berechnungsdetails.sollzinsbindung.jahre],
        'purchase_price' : [kaufpreis]
      }
    })
  }
}

export {trackGAEvent, trackRechnerInput, trackFinBestaetigungInput, trackProduct}
